export class Customer {
	public id;

	constructor(obj) {
		this.id = obj.id;
	}
} 
